import React, { useEffect } from 'react';
import './Toast.css';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface Toast {
  id: string;
  message: string;
  type: ToastType;
  duration?: number;
}

export interface ToastProps extends Toast {
  onClose: (id: string) => void;
}

const ToastComponent: React.FC<ToastProps> = ({ id, message, type, duration = 5000, onClose }) => {
  console.log('🎨 TOAST COMPONENT: Rendering toast with ID:', id, 'type:', type, 'message:', message);
  
  useEffect(() => {
    console.log('🎨 TOAST COMPONENT: useEffect called for toast ID:', id);
    if (duration > 0) {
      console.log('🎨 TOAST COMPONENT: Setting timeout for', duration, 'ms');
      const timer = setTimeout(() => {
        console.log('🎨 TOAST COMPONENT: Timeout expired, closing toast ID:', id);
        onClose(id);
      }, duration);
      return () => {
        console.log('🎨 TOAST COMPONENT: Cleanup - clearing timeout for toast ID:', id);
        clearTimeout(timer);
      };
    }
  }, [id, duration, onClose]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '⚠';
      case 'info':
        return 'ℹ';
      default:
        return '•';
    }
  };

  return (
    <div className={`toast toast-${type}`}>
      <div className="toast-icon">{getIcon()}</div>
      <div className="toast-message">{message}</div>
      <button
        className="toast-close"
        onClick={() => onClose(id)}
        aria-label="Close notification"
      >
        ×
      </button>
    </div>
  );
};

export interface ToastContainerProps {
  toasts: Toast[];
  onClose: (id: string) => void;
}

export const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onClose }) => {
  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <ToastComponent
          key={toast.id}
          {...toast}
          onClose={onClose}
        />
      ))}
    </div>
  );
};

export default ToastComponent;
